import { render, staticRenderFns } from "./JudgementListBottomContent.vue?vue&type=template&id=5cee168c&scoped=true&"
import script from "./JudgementListBottomContent.vue?vue&type=script&lang=ts&"
export * from "./JudgementListBottomContent.vue?vue&type=script&lang=ts&"
import style0 from "./JudgementListBottomContent.vue?vue&type=style&index=0&id=5cee168c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cee168c",
  null
  
)

export default component.exports